module.exports = __webpack_public_path__ + "static/media/5.6ef53409.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/unused icon/5.svg
// module id = 424
// module chunks = 14